import ProductScoringCard from './ProductScoringCard';

export default ProductScoringCard;
